/**
 * Shared constants for summary components
 */

/**
 * Regex pattern to match artifact tags in summary content
 * Matches: [CONVERSATION://id], [AUDIO_NOTE://id], [INSIGHT://id]
 * Use this for non-global replacements or when you need a fresh regex instance each time
 */
export const ARTIFACT_TAG_REGEX = /\[(CONVERSATION|AUDIO_NOTE|INSIGHT):\/\/[^\]]+\]/g

/**
 * Regex pattern to match markdown artifact links in summary content
 * Matches: [descriptive text](CONVERSATION://id), [text](AUDIO_NOTE://id), [text](INSIGHT://id)
 * Capture group 1 contains the descriptive text
 */
export const ARTIFACT_MARKDOWN_LINK_REGEX = /\[([^\]]+)\]\((CONVERSATION|AUDIO_NOTE|INSIGHT):\/\/[^)]+\)/g

/**
 * Creates a regex pattern to match artifact tags in summary content
 * Matches: [CONVERSATION://id], [AUDIO_NOTE://id], [INSIGHT://id]
 * Returns a new regex instance each time to avoid stateful issues with the global flag
 */
export const createArtifactTagRegex = () => /\[(CONVERSATION|AUDIO_NOTE|INSIGHT):\/\/([^\]]+)\]/g
